import React, { useMemo } from "react";

import { View, Text, StyleSheet } from "react-native";

import Table from "./table/table";
import Waiting from "./table/waiting";
import VideoPlayer from "./table/videoPlayer";

export default function App() {
  const params = useMemo(() => {
    const searchParams = new URLSearchParams(window.location.search);

    return {
      tableId: searchParams.get("tableId"),
      userId: searchParams.get("userId"),
      handHistoryId: searchParams.get("handHistoryId"),
      replay: searchParams.get("replay"),
    };
  }, []);

  const route = window.location.pathname;

  const renderScreen = () => {
    // Public health-check route so uptime monitors can confirm the app is serving.
    if (route === "/health") {
      return (
        <View style={styles.healthContainer}>
          <Text style={styles.healthText}>Server is healthy</Text>
        </View>
      );
    }

    if (route === "/re-play") {
      return (
        <Waiting
          tableId={params.tableId}
          userId={params.userId}
          handHistoryId={params.handHistoryId}
          replay={params.replay}
        />
      );
    }

    

    if (route === "/replay") {
      return (
        <Table
          tableId={params.tableId}
          userId={params.userId}
          handHistoryId={params.handHistoryId}
          replay={params.replay}
        />
      );
    }

    return (
      <Waiting
        tableId={params.tableId}
        userId={params.userId}
        handHistoryId={params.handHistoryId}
        replay={params.replay}
      />
    );
  };

  return (
    <View style={styles.root}>
      <View style={styles.mobileFrame}>{renderScreen()}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#111",
  },

  mobileFrame: {
    width: 390,
    height: 844,
    overflow: "hidden",
    borderColor: "#333",
    backgroundColor: "black",
  },

  healthContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },

  healthText: {
    color: "#22c55e",
    fontSize: 20,
    fontWeight: "600",
  },
});
